import React, { useState } from 'react';

import Loader from 'app/components/Loader';
import Button, { buttonThemes } from 'app/components/Button';

import styles from './styles.css';

const NewsLetterForm = ({ hasDarkButton }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');

  // Replace this URL with your Google Apps Script web app URL
  const GOOGLE_SCRIPT_URL =
    'https://script.google.com/macros/s/AKfycby-lxtl4eV1xRJZQgQDyJliItbxwqFd59pS9BCR_QhLzGjHTOsoeqU0OgrfXsxGbRSa/exec';

  const handleSubmit = async e => {
    e.preventDefault();

    if (!email || email.indexOf('@') === -1) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    setStatus('sending');
    setMessage('');

    try {
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8',
        },
        body: JSON.stringify({
          email: email,
          timestamp: new Date().toLocaleString(),
        }),
      });

      if (response.status === 200 || response.status === 302) {
        setStatus('success');
        setMessage(
          'Thank you for joining our mission. Prick intel coming soon.'
        );
        setEmail('');
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          className={styles.input}
          value={email}
          onChange={e => setEmail(e.target.value)}
          disabled={status === 'sending'}
        />
        <Button
          label="Submit"
          type="submit"
          onClick={handleSubmit}
          theme={hasDarkButton && buttonThemes.DARK}
          disabled={status === 'sending'}
        />

        <div className={styles.responseContainer}>
          {status === 'sending' && <Loader classes={styles.loader} />}
          {status === 'error' && (
            <div className={styles.message}>{message}</div>
          )}
          {status === 'success' && (
            <div className={styles.message}>{message}</div>
          )}
        </div>
      </form>
    </div>
  );
};

export default NewsLetterForm;



// WEBPACK FOOTER //
// ./src/components/Newsletter/Form/index.js